import { all, fork } from 'redux-saga/effects'
import axios from 'axios'
import user from './user'
import initial from './initial'
import category from './category'
import medium from './medium'

axios.defaults.baseURL = process.env.REACT_APP_API_URL

export default function* rootSaga() {
    yield all([
        fork(user),
        fork(initial),
        fork(category),
        fork(medium),
    ])
}



// WEBPACK FOOTER //
// ./src/estimate_list/sagas/index.js